import calcRank from "../helpers/calcRank";
//----------------
// calc all ranks
//----------------
export default function calcAllRanks(item, index, arr) {
  arr[index].rank = calcRank(arr[index]);
}
